import { useRouter } from '@edreamsodigeo/frontend-core';

const TOKEN_TD_REGEX = /td=([^;/&#]+);?/;

export const useGetTokenFromURL = () => {
  const { query, pathname = '' } = useRouter();

  // Retrieve the token if it has been defined as parameter in the router, e.g. /path/[token]/other
  const tokenQuery = query?.token as string;

  // Retrieve the token if it is defined as "td=", e.g. /path/td=1234567890;other
  const matchTd = pathname.match(TOKEN_TD_REGEX);
  const tokenTd = matchTd ? matchTd[1] : null;

  return tokenQuery ?? tokenTd;
};
